import type { ProjectUndeliveredFamilies } from '@avisoma/shared';
import { Badge } from '../../catalyst/badge';
import { formatDateTime } from '../../lib/dateFormat';
import { formatFailureCount, listUndeliveredFamilies } from './undeliveredFamilyMeta';

/**
 * One reason-coloured chip per owed family (DR-2855), for dense table rows.
 * Each chip carries the reason meaning, message and timing on hover.
 */
export function UndeliveredFamilyChips({ families }: { families?: ProjectUndeliveredFamilies | null }) {
  const entries = listUndeliveredFamilies(families);

  if (entries.length === 0) {
    return <span className="text-gray-400 dark:text-zinc-500">—</span>;
  }

  return (
    <div className="flex flex-wrap gap-1">
      {entries.map(({ family, label, detail, meta }) => (
        <span
          key={family}
          title={[
            meta.meaning,
            `${formatFailureCount(detail.failures)}, first seen ${formatDateTime(detail.firstSeenAt)}`,
            detail.message,
            detail.path && `Refusing field: ${detail.path}`,
          ]
            .filter(Boolean)
            .join('\n')}
        >
          <Badge color={meta.color}>
            {label} · {meta.label}
          </Badge>
        </span>
      ))}
    </div>
  );
}
